export default {"src":"/blog/_next/static/media/logo.14836b80.svg","height":52,"width":105};